import type { CustomerCreatedChannel } from '@anyx/common-graphql';

export function resolveCustomerCreatedChannel(channel: CustomerCreatedChannel) {
  if (channel.__typename === 'CustomerCreatedMessagingChannel') {
    return channel.chatType;
  }
  if (channel.__typename === 'CustomerCreatedSaleChannel') {
    return channel.saleChannel;
  }
  return undefined;
}
